<div class="pme-container">
  <div class="display-utils-col display-utils-gt-sm-row display-utils-center" *ngIf="this.showErrorHero">
    <div class="pme-col display-utils-gt-sm-flex-50">
      <pme-hero *ngIf="this.showHero" type="{{this.heroData.type}}" title="{{this.heroData.title}}"
        showButton="{{this.heroData.showButton}}" buttonName="{{this.heroData.buttonName}}"
        redirectURL="{{this.heroData.redirectURL}}">
        <p *ngFor="let content of this.heroData.contents">{{content}}</p>
      </pme-hero>
    </div>
  </div>

  <!-- Configuração da inversão de coluna em telas menores -->
  <div *ngIf="!this.showErrorHero" class="pme-row display-utils-col-reverse display-utils-gt-sm-row display-utils-center display-utils-gap-0 display-utils-gt-sm-gap-118">
    <div class="pme-col display-utils-gt-sm-flex-70">
      <div class="display-utils-hide-lt-md">
        <span class="pme-heroData-title">{{this.heroData.title}}</span>
        <p>{{this.heroData.contents}}</p>
      </div>

      <div *ngIf=" this.discountBadgeCreditCard">
        <div class="economyCardCreditMessage">
          <img id="gift" src="/assets/images/dialog-icons/sell.svg">
          <div>
            <p>Pague com o <span class="highlight">Cartão de Crédito</span> <br class="broken-line"> <strong> e ganhe
                {{this.discountBadgeCreditCard}}% na próxima
                fatura</strong></p>
          </div>
        </div>
      </div>
      <main>
        <h2 class="mat-subheading-2" *ngIf="!this.showHero">Nova forma de pagamento</h2>
        <pme-payment-form *ngIf="this.showForm" [buttonName]="this.buttonName" [paymentOptions]="this.paymentOptions"
          [termOfUse]="this.termOfUse" [paymentChangeProduct]="this.currentProduct"
          [discountBadgeCreditCard]="this.discountBadgeCreditCard" [creditCardData]="this.creditCardData"
          [creditCardsData]="this.creditCardsData" [maxLimitCreditCards]="maxLimitCreditCards"
          [context]="'PAYMENT_CHANGE'" [hideConditions]="false"
          (paymentMethodSelected)="this.onPaymentMethodSelected($event)"
          (formSubmitted)="onPaymentChangePerform($event)" [paymentChangeMessage]="this.paymentChangeMessage"
          (deleteCreditCard)="handleDeleteCreditCard($event)">
        </pme-payment-form>
      </main>
    </div>
    <div class="pme-heroData-title-mobile display-utils-hide-gt-sm">
      <span class="pme-heroData-title">{{this.heroData.title}}</span>
      <p>{{this.heroData.contents}}</p>
    </div>
    <div class="pme-col display-utils-gt-sm-flex-30">
      <div content>
        <aside>
          <pme-product-choice *ngIf="this.showCurrentPlan" [cardTitle]="'Meu plano'" [changeText]="" [changeLink]=""
            [productName]="this.currentPlanData.planName" [totalValue]="this.currentPlanData.totalValue"
            [description]="">
            <div class="second-divider">
              <mat-divider inset></mat-divider>
            </div>
            <ul>
              <li class="pme-product-choice-item mat-h3 last-charge display-utils-row display-utils-between-center display-utils-gap-60" *ngIf="this.currentPlanData.invoiceDate">
                <div>
                  <p>Última cobrança</p>
                </div>
                <div class="pme-text-right">{{this.currentPlanData.invoiceDate}}</div>
              </li>
              <li class="pme-product-choice-item mat-h3 card-container display-utils-col display-utils-between display-utils-gap-8" *ngIf="this.currentPaymentMethod === 'CREDIT_CARD'">
                <div class="registered-card">
                  <p>Cartão cadastrado</p>
                </div>
                <div class="display-utils-row display-utils-start-center display-utils-gap-16" style="gap: 16px;">
                  <div class="pme-payment-icon-wrapper">
                    <div class="payment-icon pme-payment-icon-{{this.currentPlanData.brand}}"></div>
                  </div>
                  <div class="pme-text-right card-number">Final
                    {{formatCreditCardNumber(this.currentPlanData.creditCard)}}</div>
                </div>
              </li>
              <li class="pme-product-choice-item mat-h3 display-utils-row display-utils-between-center display-utils-gap-8" *ngIf="this.currentPaymentMethod === 'BANK_BILLET'">
                <div>
                  <p>Forma de pagamento</p>
                </div>
                <div class="pme-text-right">Boleto bancário</div>
              </li>
              <li class="pme-product-choice-item mat-h3 display-utils-row display-utils-between-center display-utils-gap-8" *ngIf="this.currentPaymentMethod === 'PIX'">
                <div>
                  <p>Forma de pagamento</p>
                </div>
                <div class="pme-text-right">Pix</div>
              </li>
            </ul>
          </pme-product-choice>


        </aside>
        <a href="{{this.redirectUrl}}" class="back-button display-utils-only-gt-sm">
          <div class="button-container">
            <p>Voltar</p>
          </div>
        </a>
      </div>

    </div>
  </div>
</div>